import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { concatMap } from 'rxjs/operators';
import * as moment from 'moment-timezone';
import { UtilitiesService } from '../../../core/services/utilities.service';
import { BooksService } from '../../../core/services/data/books.service';
import { UserService } from '../../../core/services/data/user.service';
import { AnalyticsService } from '../../../core/services/analytics.service';
import { OrderService } from '../../../core/services/data/order.service';

import { PurchaseProcessService } from '../../../core/services/data/purchase-process.service';
import { IUser } from '../../../types/datatypes';

@Component({
	selector: 'app-cart-success',
	templateUrl: './cart-success.component.html',
	styleUrls: ['./cart-success.component.scss'],
})
export class CartSuccessComponent implements OnInit {
	public order;

	public hasUser = false;

	public user: IUser;

	public events;

	public features;

	public promostacks;

	public subscription;

	public subscriptionRenewal: string;

	public orderId: string;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private as: AnalyticsService,
		private os: OrderService,
		private us: UtilitiesService,
		private bs: BooksService,
		private uss: UserService,
		private purchaseProcessService: PurchaseProcessService,
	) {
	}

	get orderTotal() {
		return this.order?.totalAmount || 0;
	}

	get authorLink(): string {
		return this.purchaseProcessService.authorLink;
	}

	get featuresLink(): string {
		if (!this.authorLink) return '/features';
		return `/author-dashboard/${this.authorLink}/features`;
	}

	get promotionsLink(): string {
		if (!this.authorLink) return '/features';
		return `/author-dashboard/${this.authorLink}/promotions`;
	}

	get hasEvent() {
		return this.events && this.events.length > 0;
	}

	ngOnInit() {
		window.scrollTo(0, 0);
		this.route.params.pipe(concatMap(({ orderId }) => {
			this.orderId = orderId;
			return this.os.fetchOrderByID(this.orderId);
		})).subscribe((data: any) => {
			this.order = data.order;

			this.features = this.order.items
				.filter((item) => item.itemType === 'featuredBook')
				.map((item) => {
					item.item.pubDate = moment(item.item.pubDate, 'YYYYMMDD').format('MMMM Do YYYY');
					return item.item;
				});

			this.promostacks = this.order.items
				.filter((item) => item.itemType === 'promoStack')
				.map((item) => {
					const [_startDate] = item.item.startDate.match(/(\d{4})-(\d{2})-(\d{2})/);

					item.item.startDate = moment(_startDate, 'YYYY-MM-DD').format('MMMM Do YYYY');
					return item.item;
				});

			this.subscription = this.order.items.find((item) => item.itemType === 'subscription');

			this.events = this.order.items
				.filter((item) => item.itemType === 'event')
				.map((item) => {
					item.item.date = moment(item.item.date).tz('America/New_York').format('MMM D, YYYY h:mm A z');
					return item.item;
				});

			if (this.subscription) {
				this.subscriptionRenewal = moment(this.order.orderCompletedDate).add(1, 'year').format('MMMM Do YYYY');
			}

			this.uss.storeData(this.order.purchaserInfo);
		});

		this.uss.fetchUser().then((data: any) => {
			this.hasUser = true;
			this.user = data;
		}, () => {
			this.hasUser = false;
		});
	}

	startOver() {
		this.purchaseProcessService.clearDetails();
		this.router.navigate(['/']).then((success) => this.router.navigate([this.featuresLink]));
	}

	promotions() {
		this.purchaseProcessService.clearDetails();
		this.router.navigate(['/']).then((success) => this.router.navigate([this.promotionsLink]));
	}

	isFreeMember() {
		return this.uss.isFreeMember();
	}
}
